<h1 class="text-white text-lg font-semibold mb-4">Gestión de Entidades</h1>
<div class="mb-4 flex justify-between items-center">
    <button matButton (click)="onCreateEntity()" *ngIf="canCreateEntity$ | async">Crear Nueva Entidad</button>
    <mat-form-field class="ml-4 border-0">
        <input matInput (input)="applyFilter($event)" placeholder="Buscar...">
    </mat-form-field>
</div>
<div *ngIf="dataSource.data.length === 0" class="text-center py-8 text-gray-500">
    <p>No hay entidades registradas.</p>
</div>
<div class="mat-elevation-z2">
    <table mat-table [dataSource]="dataSource" matSort class="w-full">
        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Nombre </th>
            <td mat-cell *matCellDef="let entity"> {{ entity.name }} </td>
        </ng-container>
        <ng-container matColumnDef="entityEmail">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Email </th>
            <td mat-cell *matCellDef="let entity" class="no-uppercase"> {{ entity.entityEmail }} </td>
        </ng-container>
        <ng-container matColumnDef="legalRepresentative">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Representante Legal </th>
            <td mat-cell *matCellDef="let entity"> {{ entity.legalRepresentative }} </td>
        </ng-container>
        <ng-container matColumnDef="legalRepresentativeEmail">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Email Representante </th>
            <td mat-cell *matCellDef="let entity" class="no-uppercase"> {{ entity.legalRepresentativeEmail }} </td>
        </ng-container>
        <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Activo </th>
            <td mat-cell *matCellDef="let entity"> {{ entity.status ? 'Sí' : 'No' }} </td>
        </ng-container>
        <ng-container matColumnDef="createdAt">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Creado </th>
            <td mat-cell *matCellDef="let entity">{{ entity.createdAt | date:'dd-MM-yyyy, hh:mm:ss a' }}</td>
        </ng-container>
        <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef> Acciones </th>
            <td mat-cell *matCellDef="let entity">
                <button mat-icon-button color="accent" aria-label="Editar entidad" (click)="onEditEntity(entity)" *ngIf="canEditEntity$ | async">
                    <mat-icon>edit</mat-icon>
                </button>
                <button mat-icon-button color="warn" aria-label="Eliminar entidad" (click)="onDeleteEntity(entity.id)" *ngIf="canDeleteEntity$ | async">
                    <mat-icon>delete</mat-icon>
                </button>
            </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    <mat-paginator [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons aria-label="Seleccionar página de entidades"></mat-paginator>
</div>
